/**
 * @generated SignedSource<<7c9ce5c14c7516909a3066c9fde06aeb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponent_componentModule$data = {
  readonly ctaLink: string | null;
  readonly userType: string | null;
  readonly videoId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentTitle_componentModule" | "HpSharedVideoComponentVideo_componentModule">;
  readonly " $fragmentType": "HpSharedVideoComponent_componentModule";
};
export type HpSharedVideoComponent_componentModule$key = {
  readonly " $data"?: HpSharedVideoComponent_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponent_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponent_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaLink",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedVideoComponentTitle_componentModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedVideoComponentVideo_componentModule"
    }
  ],
  "type": "VideoModule",
  "abstractKey": null
};

(node as any).hash = "082cfb0ab71cab2770af88a08c5a3045";

export default node;
